var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
export const ThemeProvider = ({ brand, children }) => {
    useEffect(() => {
        const loadTheme = (brandId) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield import(/* webpackChunkName: "[request]" */ `../../themes/${brandId}/theme.css`);
            }
            catch (error) {
                yield import(/* webpackChunkName: "default-theme-css" */ '../../themes/default/theme.css');
            }
        });
        loadTheme(brand);
    }, [brand]);
    return _jsx(_Fragment, { children: children });
};
